export const kpiSelector = (state) => state.kpi;